import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const paper = css`
  padding: ${size[32]};
  margin-bottom: ${size[24]};
  text-align: center;
  display: grid;
  grid-gap: ${size[16]};

  ${breakpoint.up('sm')} {
    margin-bottom: ${size[24]};
  }
`
export const header = css`
  margin-bottom: ${size[24]};

  ${breakpoint.up('sm')} {
    margin-bottom: ${size[32]};
  }
`

export const confirmButton = css`
  margin-bottom: ${size[12]};
`
